module.exports = __webpack_public_path__ + "img/20220502_104416.91c7af9a.jpg";